<template>
  <div class="">
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Ledger CSV format Report :</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <router-link :to="{ name: 'ReportDetails' }" class="button is-small is-link">Back to
              List</router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="section is-main-section">
      <div class="columns">
        <div class="column is-3">
          <div class="box">
            <div class="has-text-centered p-b-2">
              <p class="subtitle is-5 has-text-black m-t-25"><span class="requir">*</span>From Date
              </p>
              <div class="control">
                <input class="input" required type="date" title="From Date" v-model="fromDate"
                  @change="getOrderDataCSV" />
              </div>
            </div>
          </div>
        </div>

        <div class="column is-3">
          <div class="box">
            <div class="has-text-centered p-b-2">
              <p class="subtitle is-5 has-text-black m-t-25"><span class="requir">*</span>To Date
              </p>
              <div class="control">
                <input class="input" required type="date" title="To Date" v-model="toDate"
                  @change="getOrderDataCSV" />
              </div>
            </div>
          </div>
        </div>

        <div class="column is-3">
          <div class="has-text-centered p-b-2">
            <div class="content">
              <div class="field">
                <p class="subtitle is-5 has-text-black m-t-25">Franchisee(Optional)</p>
                <div class="control">
                  <span class="select is-fullwidth">
                    <select required v-model="franchiseeID" @change="getOrderDataCSV">
                      <option value="">---All Franchisee---</option>
                      <option :value="franchisee.id" v-for="franchisee in franchiseeArr"
                        :key="franchisee.id">{{ franchisee.companyName }}</option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns ">
        <div class="column is-2"></div>
        <div class="column is-3">
          <b-button @click="downloadCSVFile()" type="is-primary" size="is-large"
            icon-left="briefcase-download">Export
            <!-- <b-icon class="has-text-warning m-t-15" icon="briefcase-download" size="is-large"> </b-icon>
            <p class="subtitle is-5 has-text-black m-t-25">Export</p>   -->
          </b-button>
        </div>
        <div class="column"></div>
      </div>
    </section>
  </div>
</template>
<script>
// import moment from 'moment'
// @ is an alias to /src
import constants from '@/utils/constants'
import ExportUtility from '@/utils/exportUtility'

import moment from 'moment'

export default {
  name: 'LedgerReportDetails',

  data () {
    return {
      ledgerData: [],
      franchiseeArr: [],
      fromDate: new Date(),
      toDate: new Date(),
      franchiseeID: '',
      loadingComponent: null,
      fName: 'LedgerReport'
    }
  },

  async created () {
    this.fromDate = moment(this.fromDate)
      .add(-1, 'day')
      .format('YYYY-MM-DD')
    this.toDate = moment(this.toDate)
      .add(0, 'day')
      .format('YYYY-MM-DD')

    await this.getFranchiseeList()
    await this.getOrderDataCSV()
  },

  methods: {
    getOrderDataCSV: async function () {
      try {
        if (moment(this.toDate).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD') || moment(this.fromDate).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD')) {
          return this.$buefy.dialog.alert({
            message: 'Date Should be less than or equal to Current Date',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Fetching Order details', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getFranchiseeList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.franchiseeArr = data.rows
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    downloadCSVFile: async function () {
      try {
        if (moment(this.toDate).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD') || moment(this.fromDate).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD')) {
          return this.$buefy.dialog.alert({
            message: 'Date Should be less than or equal to Current Date',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        let reportObj = {
          fromDate: this.fromDate,
          toDate: this.toDate
        }
        if (this.franchiseeID) {
          reportObj.franchiseeID = this.franchiseeID
        }

        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/ledger/report`, {
          params: reportObj
        })
        this.ledgerData = response.data
        if (this.ledgerData.length === 0) {
          this.$buefy.dialog.alert({
            message: 'No Record in File',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        this.loadingComponent.close()

        this.total = response.data.count
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Fetching Order details', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      this.fName = this.fName + `${moment().format('DD-MM-YYYY')}`
      ExportUtility.convertToCsv(this.ledgerData, this.fName)
    }
  }
}
</script>
<style scoped>
.requir {
  color: red;
}
</style>
